(() => {
  const ADDON_VARIANT_ID = 51866131366190;
  const TRIGGER_PROPERTY = '_auto_add_trigger';
  const AUTO_ADDED_PROPERTY = '_auto_added_companion';
  const SUPPRESS_KEY = 'shella_auto_addon_suppressed';
  const EXCLUDED_PROPERTY = '_dship_excluded';

  let isSyncing = false;
  let queuedSync = false;
  let isInternalCartChange = false;

  function getCartData() {
    if (
      window.theme &&
      theme.cart &&
      theme.cart.currentData &&
      Array.isArray(theme.cart.currentData.items)
    ) {
      return theme.cart.currentData;
    }

    return null;
  }

  function isSuppressed() {
    return sessionStorage.getItem(SUPPRESS_KEY) === 'true';
  }

  function suppressAddon() {
    sessionStorage.setItem(SUPPRESS_KEY, 'true');
    updateDshipVisibility(false);
  }

  function clearSuppression() {
    sessionStorage.removeItem(SUPPRESS_KEY);
  }

  function hasQualifyingProduct(cart) {
  return !!(cart && cart.items && cart.items.some((item) => {
    const props = item.properties || {};

    return (
      String(props[TRIGGER_PROPERTY]) === 'true' &&
      String(props[EXCLUDED_PROPERTY]) !== 'true'
    );
  }));
}

  function getAddonItems(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];

    return cart.items.filter(
      (item) => Number(item.variant_id) === Number(ADDON_VARIANT_ID)
    );
  }

  function hasAddon(cart) {
    return getAddonItems(cart).length > 0;
  }

  function updateDshipVisibility(addonInCart) {
    document.querySelectorAll('.dship').forEach((el) => {
      el.style.display = addonInCart ? 'none' : '';
    });
  }

  function syncDshipFromCart(cart) {
    updateDshipVisibility(hasAddon(cart));
  }

  function addAddon() {
    return theme.cart.addItems([
      {
        id: ADDON_VARIANT_ID,
        quantity: 1,
        properties: {
          [AUTO_ADDED_PROPERTY]: 'true'
        }
      }
    ]);
  }

  function changeLine(line, quantity) {
    isInternalCartChange = true;

    return theme.cart.changeItemByLine(line, quantity)
      .catch((error) => {
        console.error('[Shella Auto Add Companion] changeLine failed', { line, quantity, error });
        throw error;
      })
      .finally(() => {
        isInternalCartChange = false;
      });
  }

  function refreshCartUI(showPopup = false) {
    theme.cart.updateCart();

    if (showPopup) {
      theme.cart.showPopup();
    }
  }

  function removeExtraAddonsFromFreshCart() {
    return theme.cart.updateData().then(() => {
      const freshCart = getCartData();
      const addonItems = getAddonItems(freshCart);

      if (addonItems.length <= 1) {
        return Promise.resolve();
      }

      const extras = addonItems.slice(1);

      return extras.reduce((promise, item) => {
        return promise.then(() => changeLine(item.line, 0));
      }, Promise.resolve());
    });
  }

  function normalizeSingleAddonQuantityFromFreshCart() {
    return theme.cart.updateData().then(() => {
      const freshCart = getCartData();
      const addonItems = getAddonItems(freshCart);

      if (!addonItems.length) {
        return Promise.resolve();
      }

      const firstAddon = addonItems[0];
      if (Number(firstAddon.quantity) > 1) {
        return changeLine(firstAddon.line, 1);
      }

      return Promise.resolve();
    });
  }

  function removeAllAddonsFromFreshCart() {
    return theme.cart.updateData().then(() => {
      const freshCart = getCartData();
      const addonItems = getAddonItems(freshCart);

      if (!addonItems.length) {
        return Promise.resolve();
      }

      return addonItems.reduce((promise, item) => {
        return promise.then(() => changeLine(item.line, 0));
      }, Promise.resolve());
    });
  }

  function finalizeSync() {
    isSyncing = false;

    if (queuedSync) {
      queuedSync = false;
      return syncAddon(false);
    }

    return Promise.resolve();
  }

  function syncAddon(showPopup = false) {
    if (!window.theme || !theme.cart) {
      return Promise.resolve();
    }

    if (isSyncing) {
      queuedSync = true;
      return Promise.resolve();
    }

    isSyncing = true;

    const run = () => {
      const cart = getCartData();

      if (!cart || !cart.items) {
        updateDshipVisibility(false);
        return finalizeSync();
      }

      const qualifyingExists = hasQualifyingProduct(cart);
      const addonItems = getAddonItems(cart);
      const addonExists = addonItems.length > 0;

      syncDshipFromCart(cart);

      if (cart.item_count === 0 || !qualifyingExists) {
        clearSuppression();

        if (addonExists) {
          return removeAllAddonsFromFreshCart()
            .then(() => theme.cart.updateData())
            .then(() => {
              const updatedCart = getCartData();
              syncDshipFromCart(updatedCart || { items: [] });
              refreshCartUI(false);
            })
            .catch((error) => {
              console.error('[Shella Auto Add Companion] removeAllAddonsFromFreshCart failed', error);
            })
            .finally(finalizeSync);
        }

        updateDshipVisibility(false);
        return finalizeSync();
      }

      if (isSuppressed()) {
        syncDshipFromCart(cart);
        return finalizeSync();
      }

      if (!addonExists) {
        return addAddon()
          .then((response) => {
            if (response && response.ok === false) {
              return response;
            }

            return theme.cart.updateData(response).then(() => {
              const updatedCart = getCartData();
              syncDshipFromCart(updatedCart || cart);
              refreshCartUI(showPopup);
              return response;
            });
          })
          .catch((error) => {
            console.error('[Shella Auto Add Companion] addAddon failed', error);
          })
          .finally(finalizeSync);
      }

      if (addonItems.length > 1 || (addonItems[0] && Number(addonItems[0].quantity) > 1)) {
        return removeExtraAddonsFromFreshCart()
          .then(() => normalizeSingleAddonQuantityFromFreshCart())
          .then(() => theme.cart.updateData())
          .then(() => {
            const updatedCart = getCartData();
            syncDshipFromCart(updatedCart || cart);
            refreshCartUI(false);
          })
          .catch((error) => {
            console.error('[Shella Auto Add Companion] normalize addon failed', error);
          })
          .finally(finalizeSync);
      }

      syncDshipFromCart(cart);
      return finalizeSync();
    };

    if (!theme.cart.hasData) {
      return theme.cart.updateData()
        .then(run)
        .catch((error) => {
          console.error('[Shella Auto Add Companion]', error);
          isSyncing = false;
          updateDshipVisibility(false);
        });
    }

    return run().catch((error) => {
      console.error('[Shella Auto Add Companion]', error);
      isSyncing = false;
      updateDshipVisibility(false);
    });
  }

  function patchCartAddMethods() {
    if (!window.theme || !theme.cart || theme.cart.__autoAddonPatched) {
      return;
    }

    theme.cart.__autoAddonPatched = true;

    const originalAddItems = theme.cart.addItems.bind(theme.cart);
    const originalAddItem = theme.cart.addItem.bind(theme.cart);

    theme.cart.addItems = function(items) {
      return originalAddItems(items).then((response) => {
        const containsAddon =
          Array.isArray(items) &&
          items.some((item) => Number(item.id) === Number(ADDON_VARIANT_ID));

        if (!containsAddon) {
          clearSuppression();
        }

        return theme.cart.updateData(response).then(() => {
          const cart = getCartData();
          syncDshipFromCart(cart || { items: [] });

          if (response && response.ok && !containsAddon) {
            return syncAddon(true).then(() => response);
          }

          return response;
        });
      });
    };

    theme.cart.addItem = function(item) {
      return originalAddItem(item).then((response) => {
        const isAddon = item && Number(item.id) === Number(ADDON_VARIANT_ID);

        if (!isAddon) {
          clearSuppression();
        }

        return theme.cart.updateData(response).then(() => {
          const cart = getCartData();
          syncDshipFromCart(cart || { items: [] });

          if (response && response.ok && !isAddon) {
            return syncAddon(true).then(() => response);
          }

          return response;
        });
      });
    };
  }

  function patchCartChangeMethods() {
    if (!window.theme || !theme.cart || theme.cart.__autoAddonChangePatched) {
      return;
    }

    theme.cart.__autoAddonChangePatched = true;

    const originalChangeItemByLine = theme.cart.changeItemByLine.bind(theme.cart);
    const originalChangeItemById = theme.cart.changeItemById.bind(theme.cart);

    theme.cart.changeItemByLine = function(line, quantity) {
      const previousCart = getCartData();
      const lineIndex = Number(line) - 1;
      const previousItem =
        previousCart && previousCart.items && previousCart.items[lineIndex]
          ? previousCart.items[lineIndex]
          : null;

      if (
        previousItem &&
        Number(previousItem.variant_id) === Number(ADDON_VARIANT_ID) &&
        Number(quantity) === 0
      ) {
        suppressAddon();
      }

      return originalChangeItemByLine(line, quantity).then((data) => {
        return theme.cart.updateData(data).then(() => {
          const cart = getCartData();
          syncDshipFromCart(cart || { items: [] });
          refreshCartUI(false);

          if (isInternalCartChange) {
            return data;
          }

          if (cart && cart.items && hasQualifyingProduct(cart)) {
            return syncAddon(false).then(() => data);
          }

          if (!cart || !cart.items || !hasQualifyingProduct(cart)) {
            clearSuppression();
            return syncAddon(false).then(() => data);
          }

          return data;
        });
      }).catch((error) => {
        console.error('[Shella Auto Add Companion] patched changeItemByLine failed', error);
        throw error;
      });
    };

    theme.cart.changeItemById = function(id, quantity) {
      if (Number(id) === Number(ADDON_VARIANT_ID) && Number(quantity) === 0) {
        suppressAddon();
      }

      return originalChangeItemById(id, quantity).then((data) => {
        return theme.cart.updateData(data).then(() => {
          const cart = getCartData();
          syncDshipFromCart(cart || { items: [] });
          refreshCartUI(false);

          if (isInternalCartChange) {
            return data;
          }

          if (cart && cart.items && hasQualifyingProduct(cart)) {
            return syncAddon(false).then(() => data);
          }

          if (!cart || !cart.items || !hasQualifyingProduct(cart)) {
            clearSuppression();
            return syncAddon(false).then(() => data);
          }

          return data;
        });
      }).catch((error) => {
        console.error('[Shella Auto Add Companion] patched changeItemById failed', error);
        throw error;
      });
    };
  }

  function bindSuppressionWatchers() {
    document.addEventListener('click', (event) => {
      const target = event.target.closest('a, button, [data-control]');
      if (!target) return;

      if (target.matches('.js-product-button-remove-from-cart')) {
        const productRow = target.closest('[data-js-product]');
        const variantId = productRow
          ? Number(productRow.getAttribute('data-product-variant-id'))
          : null;

        if (variantId === Number(ADDON_VARIANT_ID)) {
          suppressAddon();
        }

        return;
      }

      if (target.matches('[data-control]')) {
        const productRow = target.closest('[data-js-product]');
        const variantId = productRow
          ? Number(productRow.getAttribute('data-product-variant-id'))
          : null;
        const direction = target.getAttribute('data-control');

        if (variantId === Number(ADDON_VARIANT_ID) && direction === '-') {
          const input = productRow.querySelector('.js-input-quantity-cart');
          const currentQty = input ? parseInt(input.value, 10) || 1 : 1;

          if (currentQty <= 1) {
            suppressAddon();
          }
        }
      }
    });

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      if (target.matches('.js-input-quantity-cart')) {
        const productRow = target.closest('[data-js-product]');
        const variantId = productRow
          ? Number(productRow.getAttribute('data-product-variant-id'))
          : null;
        const qty = parseInt(target.value, 10) || 0;

        if (variantId === Number(ADDON_VARIANT_ID) && qty === 0) {
          suppressAddon();
        }
      }
    });
  }

  function bindManualAddonButton() {
    document.addEventListener('click', function(event) {
      const btn = event.target.closest('.cart-drawer-add-fixed-product');
      if (!btn) return;

      event.preventDefault();

      if (!window.theme || !theme.cart) return;
      if (btn.classList.contains('is-loading')) return;

      btn.classList.add('is-loading');
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';

      clearSuppression();

      const cart = getCartData();
      if (cart && hasAddon(cart)) {
        syncDshipFromCart(cart);
        btn.classList.remove('is-loading');
        btn.textContent = originalText;
        refreshCartUI(true);
        return;
      }

      theme.cart.addItems([
        {
          id: ADDON_VARIANT_ID,
          quantity: 1,
          properties: {
            _manual_add: 'true'
          }
        }
      ])
        .then((response) => {
          if (response && response.ok === false) {
            throw new Error('Failed to add item');
          }

          return theme.cart.updateData(response).then(() => {
            const updatedCart = getCartData();
            syncDshipFromCart(updatedCart || { items: [] });
            refreshCartUI(true);
            return response;
          });
        })
        .catch((error) => {
          console.error('[Manual Add Addon]', error);
          btn.textContent = 'Error';

          setTimeout(() => {
            btn.textContent = originalText;
          }, 1500);
        })
        .finally(() => {
          btn.classList.remove('is-loading');
          if (btn.textContent === 'Adding...') {
            btn.textContent = originalText;
          }
        });
    });
  }

  window.addEventListener('load', () => {
    if (!window.theme || !theme.cart) return;

    patchCartAddMethods();
    patchCartChangeMethods();
    bindSuppressionWatchers();
    bindManualAddonButton();

    theme.cart.updateData()
      .then(() => {
        const cart = getCartData();
        syncDshipFromCart(cart || { items: [] });
        theme.cart.updateCart();
        return syncAddon(false);
      })
      .then(() => {
        const cart = getCartData();
        syncDshipFromCart(cart || { items: [] });
        theme.cart.updateCart();
      })
      .catch((error) => {
        console.error('[Shella Auto Add Companion] initial load failed', error);
      });
  });
})();